import styled from 'styled-components';
import { Colors } from '../../../types/types';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Section = styled.div<{ color: Colors }>`
  flex: 1;
  height: 2px;
  background-color: ${({ color }) => `var(--base-color-${color})`};
`;

export const BottomLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const Text = styled.div<{ color: Colors }>`
  color: ${({ color }) => `var(--base-color-${color})`};
`;

export const LabelText = styled.div<{ color: Colors }>`
  margin-top: 1px;
  white-space: nowrap;
  color: ${({ color }) => `var(--base-color-${color})`};
`;
